module.exports = __webpack_public_path__ + "media/4x3/sb-aa819297.svg";